<template>
  <div ref="scrollableContent">
    <div class="suspension" v-if="pc">
      <div>扫描二维码</div>
      <div>下载app</div>
      <img src="../../static/images/erweima2.png" alt="" />
    </div>
    <div class="index_banner-out">
      <div class="swiper-container banner-container">
        <div class="swiper-wrapper banner-wrapper">
          <div class="swiper-slide banner-slide banner-slide_2">
            <video
              class="a-j banner-slide-video-768"
              autoplay="autoplay"
              loop="loop"
              muted="muted"
              style="height: 958px"
            >
              <source
                :src="this.config.imgServer + 'zy68.mp4'"
                type="video/mp4"
              />
            </video>
            <div class="banner-slide-img-768"></div>
          </div>
          <!-- <div class="swiper-slide banner-slide banner-slide_3" @click="cclick">
            <a href="/static/images/01-1.png"></a>
            <img src="/static/images/01-1.png" />
            <div class="banner-slide-img-768"></div>
          </div> -->
        </div>
      </div>
      <!--登录START-->
      <div
        class="banner_log_on wow fadeIn"
        data-wow-duration="0.8s"
        data-wow-delay="0.2s"
        v-if="sendsystem"
      >
        <login-form @on-success-valid="handleSubmit"></login-form>
      </div>
      <div
        class="banner_log_on wow fadeIn"
        data-wow-duration="0.8s"
        data-wow-delay="0.2s"
        v-else
      >
        <div class="container">
          <ul class="banner_log_on_list row">
            <!--<li-->
            <!--class="col-lg-4 col-sm-4 col-xs-12 wow fadeInDown"-->
            <!--data-wow-duration="0.4s"-->
            <!--data-wow-delay="0.3s"-->
            <!--&gt;欢迎：{{realname}}</li>-->
            <li
              class="col-md-offset-2 col-lg-4 col-sm-offset-2 col-sm-4 col-xs-12 wow fadeInDown"
              data-wow-duration="0.4s"
              data-wow-delay="0.3s"
            >
              <input
                class="into"
                type="button"
                @click="EntrySystem()"
                value="进入系统"
                placeholder
              />
            </li>
            <li
              class="col-lg-4 col-sm-4 col-xs-12 wow fadeInDown"
              data-wow-duration="1.2s"
              data-wow-delay="0.3s"
            >
              <input
                class="logout"
                type="button"
                @click="Cancellation()"
                value="注销"
                placeholder
              />
            </li>
          </ul>
        </div>
      </div>
      <!--登录END-->
    </div>
    <!-- <logincomponents></logincomponents> -->
    <!----------- 服务项目 ---------->
    <div class="index_title_out">
      <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.4s"
        >SHANDONG &nbsp;&nbsp; ZEZHONG</span
      >
      <h4>
        <strong
          class="wow fadeInDown"
          data-wow-duration="0.4s"
          data-wow-delay="0.4s"
        >
          PROJECT
          <em>●</em> 服务项目
        </strong>
      </h4>
      <p class="wow fadeInDown" data-wow-duration="0.8s" data-wow-delay="0.4s">
        凭借过硬的专业知识和高质量服务标准，提供全方位、
        <br />高质量、专业化的医学虚拟仿真教学实验
      </p>
    </div>
    <div class="index_service_out container">
      <ul class="WOW index_service_list row">
        <li
          class="col-lg-4 col-md-4 col-sm-12 col-xs-12 wow fadeInUp"
          data-wow-duration="0.4s"
          data-wow-delay="0.3s"
          v-for="sitem in Server"
          :key="sitem.id"
        >
          <a target="_blank" @click="newsClick(sitem.id)">
            <!-- <a target="_blank"> -->
            <div class="list_con">
              <div class="img">
                <img :src="sitem.img" alt />
              </div>
              <div class="txt">
                <h6 class="font-title">{{ sitem.title }}</h6>
                <!-- <p v-html="item.content">{{item.content|ellipsis}}</p> -->
                <p class="font-text">{{ sitem.subTitle | ellipsis }}</p>
              </div>
            </div>
          </a>
        </li>
        <li
          class="col-lg-4 col-md-4 col-sm-12 col-xs-12 wow fadeInUp"
          data-wow-duration="0.4s"
          data-wow-delay="0.3s"
        >
          <a target="_blank" href="http://ks.sdzzdzkj.com">
            <!-- <a target="_blank"> -->
            <div class="list_con">
              <div class="img">
                <img src="/static/images/service-img.png" alt />
              </div>
              <div class="txt">
                <h6 class="font-title">全国医学检验大赛作品展示</h6>
                <!-- <p v-html="item.content">{{item.content|ellipsis}}</p> -->
                <p class="font-text">
                  深入推进信息技术与医学检验技术专业在临床与教学的深度融合，展示医学检验技术专业信息化建设成果。
                </p>
              </div>
            </div>
          </a>
        </li>
        <li
          class="col-lg-4 col-md-4 col-sm-12 col-xs-12 wow fadeInUp"
          data-wow-duration="0.4s"
          data-wow-delay="0.3s"
        >
          <a target="_blank" @click="newsClickSmart(true)">
            <!-- <a target="_blank"> -->
            <div class="list_con">
              <div class="img">
                <img src="/static/images/01.png" alt />
              </div>
              <div class="txt">
                <h6 class="font-title">智慧实验室管理系统</h6>
                <!-- <p v-html="item.content">{{item.content|ellipsis}}</p> -->
                <p class="font-text">
                  智慧实验室管理系统旨在利用现代信息技术解决传统实验室管理中的问题，如人员管理混乱、器材管理不规范、数据孤岛等。该平台通过实现课程管理、耗材管理、学生管理、实验过程监控、报告管理和结果评价等环节的可视化和智能化，提高实验室管理效率，减轻教师负担，优化学生学习体验。
                </p>
              </div>
            </div>
          </a>
        </li>
        <li
          class="col-lg-4 col-md-4 col-sm-12 col-xs-12 wow fadeInUp"
          data-wow-duration="0.4s"
          data-wow-delay="0.3s"
        >
          <a target="_blank" @click="newsClickSmart()">
            <!-- <a target="_blank"> -->
            <div class="list_con">
              <div class="img">
                <img src="/static/images/02.png" alt />
              </div>
              <div class="txt">
                <h6 class="font-title">临床实习管理系统</h6>
                <!-- <p v-html="item.content">{{item.content|ellipsis}}</p> -->
                <p class="font-text">
                  临床实习管理系统是一款基于信息技术的医学教育管理工具，旨在优化医学院校和医院的临床实习管理流程。系统具备智能排班、实时监控、个性化学习等特色，支持与医院现有系统对接，实现资源共享和数据交互，为医学教育的信息化发展提供了有力支持。
                </p>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <!----------- 服务项目 end ---------->
    <!----------- 公司介绍 ---------->
    <div class="index_title_out font-note">
      <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.4s"
        >SHANDONG &nbsp;&nbsp; ZEZHONG</span
      >
      <h4>
        <strong
          class="wow fadeInDown"
          data-wow-duration="0.4s"
          data-wow-delay="0.4s"
        >
          ABOUT US
          <em>●</em> 公司介绍
        </strong>
      </h4>
      <p class="wow fadeInDown" data-wow-duration="0.8s" data-wow-delay="0.4s">
        凭借过硬的专业知识和高质量服务标准，提供全方位、
        <br />高质量、专业化的医学虚拟仿真教学实验
      </p>
    </div>
    <div class="index_about_out">
      <div class="container">
        <div
          class="index_about_txt wow zoomIn"
          data-wow-duration="0.5s"
          data-wow-delay="0.4s"
          style="text-align: left"
        >
          <p style="text-align: left">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;山东泽众电子科技有限公司是一家致力于推动虚拟现实技术在医学检验教学中应用的专业公司，专注于医学检验技术专业虚拟仿真资源的开发与销售，拥有多项计
            算机著作权，其中独立申请12项，校企合作申请5项，是济南市双软企业，济南市信息技术行业重点培育企业。
          </p>
          <p style="text-align: left">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司与国内众多高校建立校企合作开发关系，包含南方医科大学、厦门大学、山东大学、天津医科大学、北华大学、广州医科大学、泰山医学院、海南医学
            院、潍坊医学院、内蒙古民族大学医学院、佛山科技技术学院、滨州医学院等。在医学检验专业虚拟仿真教学应用方面，公司产品占比80%以上。
          </p>
          <p style="text-align: left">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;开发了一系列基于Internet的医学检验专业虚拟仿真资源，包含医学检验虚拟实验资源共享平台、网络微课程、医学检验形态资源库、手工操作虚拟实验项目、虚
            拟检验科、形态在线考试系统以及临床检验案例思维训练系统等60个典型案例的检验思维训练，是国内唯一一个临床检验专业的案例思维训练系统。
          </p>
          <a target="_blank" @click="about()">
            <img :src="this.config.imgServer + 'img-4.png'" alt />
          </a>
        </div>
        <ul class="row index_about_list">
          <li>
            <dl
              class="wow fadeInDown"
              data-wow-duration="0.4s"
              data-wow-delay="0.4s"
            >
              <dt class="counter">7</dt>
              <dd>年虚拟仿真实验经验</dd>
            </dl>
          </li>
          <li>
            <dl
              class="wow fadeInDown"
              data-wow-duration="0.8s"
              data-wow-delay="0.4s"
            >
              <dt class="counter">45</dt>
              <dd>名高精尖专业技术团队</dd>
            </dl>
          </li>
          <li>
            <dl
              class="wow fadeInDown"
              data-wow-duration="1.2s"
              data-wow-delay="0.4s"
            >
              <dt class="counter">150</dt>
              <dd>余所高等医学院校的选择</dd>
            </dl>
          </li>
          <li>
            <dl
              class="wow fadeInDown"
              data-wow-duration="1.6s"
              data-wow-delay="0.4s"
            >
              <dt class="counter">240</dt>
              <dd>多个医学虚拟仿真实验</dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>
    <!----------- 公司介绍 end ---------->
    <!----------- 核心优势 ---------->
    <div class="index_title_out">
      <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.4s"
        >SHANDONG &nbsp;&nbsp; ZEZHONG</span
      >
      <h4>
        <strong
          class="wow fadeInDown"
          data-wow-duration="0.4s"
          data-wow-delay="0.4s"
        >
          technology
          <em>●</em> 核心优势
        </strong>
      </h4>
      <p class="wow fadeInDown" data-wow-duration="0.8s" data-wow-delay="0.4s">
        凭借过硬的专业知识和高质量服务标准，提供全方位、
        <br />高质量、专业化的医学虚拟仿真教学实验
      </p>
    </div>
    <div class="index_technology_out container">
      <ul class="index_technology_list row">
        <li
          class="a col-lg-3 col-sm-6 col-xs-6 wow fadeInUp"
          data-wow-duration="0.4s"
          data-wow-delay="0.2s"
        >
          <div class="con">
            <div class="icon">
              <em></em>
            </div>
            <div class="txt">
              <h6>轻量级架构</h6>
              <span></span>
              <p>
                三层开发模式，使用<br />
                Asp.Net(C#)编程语言<br />
                保持轻量级架构。
              </p>
            </div>
          </div>
        </li>
        <li
          class="b col-lg-3 col-sm-6 col-xs-6 wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          <div class="con">
            <div class="icon">
              <em></em>
            </div>
            <div class="txt">
              <h6>响应式管理界面</h6>
              <span></span>
              <p>
                界面设计友好，使用<br />
                响应式设计全面兼容<br />
                IE8及主流浏览器。
              </p>
            </div>
          </div>
        </li>
        <li
          class="c col-lg-3 col-sm-6 col-xs-6 wow fadeInUp"
          data-wow-duration="1.2s"
          data-wow-delay="0.2s"
        >
          <div class="con">
            <div class="icon">
              <em></em>
            </div>
            <div class="txt">
              <h6>可拔插插件</h6>
              <span></span>
              <p>
                支持可插拔插件，使<br />
                整个系统扩展起来更<br />
                加简单。
              </p>
            </div>
          </div>
        </li>
        <li
          class="d col-lg-3 col-sm-6 col-xs-6 wow fadeInUp"
          data-wow-duration="1.6s"
          data-wow-delay="0.2s"
        >
          <div class="con">
            <div class="icon">
              <em></em>
            </div>
            <div class="txt">
              <h6>功能自定义</h6>
              <span></span>
              <p>
                用户可以按需求在后台<br />
                创建自己需要的频道功<br />
                能及功能模块。
              </p>
            </div>
          </div>
        </li>
        <!--<li-->
        <!--class="a  wow fadeInUp"-->
        <!--data-wow-duration="0.4s"-->
        <!--data-wow-delay="0.2s"-->
        <!--v-for="ysitem in CoreStrengths"-->
        <!--&gt;-->
        <!--&lt;!&ndash; <div class="con" @click="newsClick(ysitem.id)"> &ndash;&gt;-->
        <!--<div class="con" >-->
        <!--<div class="icon">-->
        <!--<em></em>-->
        <!--</div>-->
        <!--<div class="txt">-->
        <!--<h6>{{ysitem.title}}</h6>-->
        <!--<span></span>-->
        <!--<p>{{ysitem.subTitle|ellipsis}}</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--</li>-->
      </ul>
    </div>
    <!----------- 核心优势 end ---------->
    <!----------- 新闻资讯 ---------->
    <div class="index_title_out">
      <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.4s"
        >SHANDONG &nbsp;&nbsp; ZEZHONG</span
      >
      <h4>
        <strong
          class="wow fadeInDown"
          data-wow-duration="0.4s"
          data-wow-delay="0.4s"
        >
          News
          <em>●</em> 新闻资讯
        </strong>
      </h4>
      <p class="wow fadeInDown" data-wow-duration="0.8s" data-wow-delay="0.4s">
        凭借过硬的专业知识和高质量服务标准，提供全方位、
        <br />高质量、专业化的医学虚拟仿真教学实验
      </p>
    </div>
    <div class="index_news_out">
      <div class="container">
        <div
          class="recommend_out col-lg-6 col-sm-12 col-xs-12 wow fadeInLeft"
          data-wow-duration="1s"
          data-wow-delay="0.4s"
        >
          <div v-for="onew in newsOne">
            <a target="_blank" @click="newsClick(onew.id)" class="recommend">
              <div class="img">
                <img :src="onew.img" alt />
              </div>
              <div class="txt">
                <h6>{{ onew.title }}</h6>
                <span>{{ $moment(onew.pubDate).format("YYYY-MM-DD") }}</span>
                <p>{{ onew.subTitle | ellipsis }}</p>
              </div>
            </a>
          </div>
        </div>
        <ul
          class="list col-lg-6 col-sm-12 col-xs-12 wow fadeInRight"
          data-wow-duration="1s"
          data-wow-delay="0.4s"
        >
          <li v-for="newitem in NewsAndIAnformation">
            <a target="_blank" @click="newsClick(newitem.id)">
              <dl class="time">
                <dt>{{ newitem.pubDate | dayData }}</dt>
                <dd>{{ newitem.pubDate | yearData }}</dd>
              </dl>
              <dl class="list_con">
                <dt>{{ newitem.title }}</dt>
                <dd>{{ newitem.subTitle | ellipsis }}</dd>
              </dl>
            </a>
          </li>
        </ul>
      </div>
      <div class="more">
        <a target="_blank" @click="list()">查看更多新闻</a>
      </div>
    </div>
    <!----------- 新闻资讯 end ---------->
    <!----------- 合作院校 ---------->
    <div class="index_title_out">
      <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.4s"
        >SHANDONG &nbsp;&nbsp; ZEZHONG</span
      >
      <h4>
        <strong
          class="wow fadeInDown"
          data-wow-duration="0.4s"
          data-wow-delay="0.4s"
        >
          cooperate
          <em>●</em> 合作院校
        </strong>
      </h4>
      <p class="wow fadeInDown" data-wow-duration="0.8s" data-wow-delay="0.4s">
        凭借过硬的专业知识和高质量服务标准，提供全方位、
        <br />高质量、专业化的医学虚拟仿真教学实验
      </p>
    </div>
    <!--滚动结束 -->
    <!-- <div class="index_cooperate_out">
      <div class="swiper-container index_cooperate_container">
        <div class="swiper-wrapper index_cooperate_wrapper">
     <vue-seamless-scroll
    :data="schoolList"
    :class-option="classOption"
    class="warp"
  >
    <ul class="ul-item">
      <li class="li-item swiper-slide index_cooperate_slide" v-for="(schoolitem, index) in schoolList" :key="index" >
        <img :src="schoolitem.Logo" alt />
       <div class="zz">
              <h6>{{ schoolitem.SchoolName }}</h6>
              <p>{{ schoolitem.content }}</p>
            </div>
      </li>
    </ul>
  </vue-seamless-scroll></div>
        <div class="swiper-button-next index_cooperate_button-next"></div>
        <div class="swiper-button-prev index_cooperate_button-prev"></div>
    </div></div> -->
    <!--滚动开始 -->
    <div class="index_cooperate_out">
      <div class="swiper-container index_cooperate_container">
        <div class="swiper-wrapper index_cooperate_wrapper">
          <div
            class="swiper-slide index_cooperate_slide"
            v-for="schoolitem in schoolList"
            @click="schoolurl(schoolitem.Url)"
          >
            <img :src="schoolitem.Logo" alt />
            <div class="zz">
              <h6>{{ schoolitem.SchoolName }}</h6>
              <p>{{ schoolitem.content }}</p>
            </div>
          </div>
        </div>
        <div class="swiper-button-next index_cooperate_button-next"></div>
        <div class="swiper-button-prev index_cooperate_button-prev"></div>
      </div>
    </div>
    <!-- <div
      v-if="show"
      @mouseover="mouseover"
      @mouseout="mouseout"
      class="box11"
      :style="{ top: top + 'px', left: left + 'px' }"
      @click="demo" 
    > 
      <img class="box-div" src="../assets/images/sjt.png" alt="">
    </div> -->
  </div>
</template>
<script>
import { jquery } from "jquery";
import "bootstrap";
import { WOW } from "wowjs";
import Swiper from "../../static/js/swiper.min.js";
import "../../static/js/nav.js";
import "../../static/js/jquery.aniview.js";
import "../../static/js/jquery.waypoints.min.js";
import "../../static/js/jquery.countup.min.js";
import "../../static/js/public.js";
import "../../static/css/swiper.min.css";
import "../../static/css/nav.css";
import "../../static/css/animate.min.css";
import "../../static/css/common.css";
import "../../static/css/style.css";
import Qs from "qs";

import LoginForm from "@/components/loginForm/loginForm.vue";
import md5 from "js-md5";
import moment from "moment";

import axios from "@/libs/api.request";

import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 80) {
        return value.slice(0, 80) + "...";
      }
      return value;
    },
    yearData(value) {
      return moment(value).format("YYYY-MM");
    },
    dayData(value) {
      return moment(value).format("DD");
    },
  },
  data() {
    return {
      pc: true,
      classOption: {
        limitMoveNum: 2,
        direction: 3,
      },
      //服务项目
      Server: [],
      //核心优势
      CoreStrengths: [],
      //第一条新闻
      newsOne: {},
      //新闻资讯
      NewsAndIAnformation: [],
      //合作院校
      schoolList: [],
      sendsystem: true,
      realname: "",
      top: 0,
      left: 0,
      show: true, // 是否展现飘窗
      stepX: 1, // 水平方向的步长
      stepY: 1, // 垂直方向的步长
      timer: null, // 定时器
      maxTop: 0, // 最大的 top 值
      maxLeft: 0, // 最大的 left 值
    };
  },
  components: {
    // logincomponents,
    LoginForm,
    vueSeamlessScroll,
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    //点击飘窗
    demo() {
      window.open("http://ks.sdzzdzkj.com/");
      // window.location.href = "http://60.208.121.106:8075/dasai/index.html";
    },
    // 初始化飘窗规则
    init() {
      // 设置最大的top和left值：根元素可视区域宽高 - 飘窗的宽高 - 边距
      this.maxTop = document.documentElement.clientHeight - 200 - 20;
      this.maxLeft = document.documentElement.clientWidth - 300 - 20;

      // 设置 top 和 left 的初始值
      this.top = 0;
      this.left = 0;

      // 创建定时器前清除定时器，避免类似在 onresize 中调用 init() 时，产生多个定时器
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.move();
      }, 20);

      this.onresize();
    },
    // 移动函数
    move() {
      if (this.top >= this.maxTop || this.top < 0) {
        this.stepY = -this.stepY;
      }
      if (this.left >= this.maxLeft || this.left < 0) {
        this.stepX = -this.stepX;
      }

      this.top += this.stepY;
      this.left += this.stepX;
    },
    // 鼠标悬浮在飘窗时停止移动
    mouseover() {
      clearInterval(this.timer);
    },

    // 鼠标离开飘窗时恢复移动
    mouseout() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.move();
      }, 20);
    },
    // 关闭飘窗
    close() {
      clearInterval(this.timer);
      this.show = false;
    },
    // 窗口大小调整时重置飘窗规则
    onresize() {
      const that = this;
      window.onresize = function () {
        that.init();
      };
    },
    cclick() {
      console.log(2);
      window.open(
        "/static/images/山东泽众电子科技有限公司招聘文件.pdf",
        "_blank"
      );
    },
    //注销
    Cancellation() {
      var Signout = localStorage.getItem("Signout");
      var url = localStorage.getItem("url");
      localStorage.clear();
      localStorage.setItem("Signout", Signout);
      localStorage.setItem("url", url);
      this.sendsystem = true;
    },
    //进入系统
    EntrySystem() {
      // var sendurl =
      //   localStorage.getItem("url") + localStorage.getItem("sendurl");
      var sendurl = "/" + localStorage.getItem("sendurl");
      console.log(sendurl);
      window.location.href = sendurl;
    },
    //登录
    handleSubmit({ userName, password }) {
      var posturl = this.config.baseUrl.pro + "/login/apiLogin";
      password = md5(password);
      userName = userName.trim();
      let postdata = {
        User_Name: userName,
        Secretkey: password,
        rememberClient: true,
      };
      //登录
      return axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: Qs.stringify(postdata),
        })
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            var data = resp.data.result;
            if (data.success) {
              console.log("新闻站登录：");
              console.log(resp);
              let userData = {
                userName: data.data.user.user_Name,
                realName:  data.data.user.real_Name ?data.data.user.real_Name :'',
                type: data.data.user.roleType == 3 ? 4 : data.data.user.roleType == 4 ? 3 : '',
                sex: 1,
                phoneNum: data.data.user.telephone ?data.data.user.telephone.toString() :'',
                deptId: data.data.user.department_Id ? data.data.user.department_Id.toString() :'',
                deptName: data.data.user.departmentName ?data.data.user.departmentName :'',
                classId: data.data.user.category_Id ?data.data.user.category_Id.toString() :'',
                className: data.data.user.className ?data.data.user.className :'',
                jobNumber: '',
              };
              console.log(userData)
              localStorage.setItem("userDataOldSystem", JSON.stringify(userData));
              localStorage.setItem("userid", data.data.user.id);
              localStorage.setItem("authToken", data.token);
              localStorage.setItem("account", data.data.user.user_Name);
              localStorage.setItem("realname", data.data.user.real_Name);
              localStorage.setItem("systype", data.data.sysType);
              localStorage.setItem("sendurl", data.data.url);
              localStorage.setItem("UserRoleId", data.data.user.role_Id);
              localStorage.setItem("className", data.data.user.className);
              this.sendsystem = false;

              this.getConfig();
            } else {
              // this.$Message.error("登录失败，用户名或密码错误");
              this.$Modal.error({
                title: "提示",
                content: "登录失败，" + data.message,
              });
              console.log(data.message);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
    schoolurl(src) {
      if (src != null && src !== "#") {
        window.open(src);
      }
    },
    ///登录状态判断
    loginStatus() {
      var sendurl = localStorage.getItem("sendurl");
      var token = localStorage.getItem("authToken");
      if (
        sendurl !== null &&
        sendurl !== undefined &&
        sendurl !== "" &&
        token !== null &&
        token !== undefined &&
        token !== ""
      ) {
        this.sendsystem = false;
        this.realname = localStorage.getItem("realname");
        this.getConfig();
      } else {
        this.Cancellation();
      }
    },
    getConfig(value) {
      var posturl = this.config.baseUrl.pro + "/Base_Config/apiGetConfigLoad";
      return axios
        .request({
          url: posturl,
          method: "POST",
          changeOrigin: true, //允许跨域
          headers: {
            "Content-Type": "application/x-www-form-urlenCoded",
            authToken: localStorage.getItem("authToken"),
            accept: "text/plain",
          },
        })
        .then((resp) => {
          console.log(resp);
          if (resp.status === 200) {
            var data = resp.data.Result.Data;
            console.log(data);
            for (var i = 0; i < data.length; i++) {
              var item = data[i];
              localStorage.setItem(item.Code, item.Value);
              localStorage.removeItem("TeacherEnCode");
              localStorage.removeItem("TeacherEnCodes");
              localStorage.removeItem("StudentEnCode");
              localStorage.removeItem("StudentEnCodes");
            }
            if (value) {
              this.EntrySystem();
            }
          } else {
            localStorage.clear();
            this.loginStatus();
          }
        })
        .catch((err) => {
          localStorage.clear();
          this.loginStatus();
          console.log(err);

          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
    getNewsData() {},
    ///数据加载
    getData() {
      let data = [
        { type: "Server", name: "Server", start: 0, num: 3, rec: 0 },
        {
          type: "CoreStrengths",
          name: "CoreStrengths",
          start: 0,
          num: 4,
          rec: 0,
        },
        {
          type: "NewsAndIAnformationOne",
          name: "NewsAndIAnformationOne",
          start: 0,
          num: 1,
          rec: 1,
        },
        {
          type: "NewsAndIAnformation",
          name: "NewsAndIAnformation",
          start: 1,
          num: 4,
          rec: 1,
        },
      ];
      var posturl =
        this.config.baseUrl.pro + "/Base_News/ApiIndexLoadBase_NewsCompany";
      axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域2
          data: data,
        })
        .then((resp) => {
          if (resp.status === 200) {
            //这里进行赋值
            var list = resp.data.result;
            console.log(list, "111111111111111111");
            for (var i = 0; i < list.length; i++) {
              if (list[i].newslist != null && list[i].newslist.length > 0) {
                if (list[i].name === "Server") {
                  try {
                    this.Server = list[i].newslist;
                  } catch (e) {
                    console.log(e);
                  }
                } else if (list[i].name === "CoreStrengths") {
                  this.CoreStrengths = list[i].newslist;
                } else if (list[i].name === "NewsAndIAnformationOne") {
                  this.newsOne = list[i].newslist;
                } else if (list[i].name === "NewsAndIAnformation") {
                  this.NewsAndIAnformation = list[i].newslist;
                }
              }
            }
          }
        })
        .catch((err) => {
          this.$Message.info("数据请求失败");
        });
    },
    ///新闻的点击
    newsClick(id) {
      let routeData = this.$router.resolve({
        path: "details",
        query: { id: id },
      });
      window.open(routeData.href, "_blank");
    },
    ///新闻的点击
    newsClickSmart(val) {
      if (val) {
        let routeData = this.$router.resolve({
          path: "smartLaboratory",
        });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          path: "internship",
        });
        window.open(routeData.href, "_blank");
      }
    },

    about() {
      let routeData = this.$router.resolve({ path: "about" });
      window.open(routeData.href, "_blank");
    },
    list() {
      let routeData = this.$router.resolve({ path: "newslist" });
      window.open(routeData.href, "_blank");
    },
    dataUp(datas) {
      for (var i = 0; i < datas.length; i++) {
        try {
          var datetime = new Date(datas[i].createDate);
          datas[i].yearAndMonth =
            datetime.getFullYear() + "-" + datetime.getMonth();
          datas[i].day = datetime.getDay();
          datas[i].img = this.config.imgServer + "/img-1.png";
        } catch (e) {
          console.log(i + "--" + e);
        }
      }
      return datas;
    },
    schoolData() {
      var posturl =
        this.config.baseUrl.pro +
        "/Base_PartnerSchool/GetBase_AllPartnerSchool";
      axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域2
        })
        .then((resp) => {
          var data = resp.data.Result;
          console.log(data.length);
          for (var s = 0; s < data.length; s++) {
            data[s].Logo = "http://sdzzdzkj.com/" + data[s].Logo;
          }
          this.schoolList = data;
        })
        .catch((err) => {
          console.log(err);
          this.$Message.info("数据请求失败");
        });
    },
    swLoad() {
      var that = this;
      that.$nextTick(function () {
        var mySwiper = new Swiper(".index_cooperate_container", {
          observer: true,
          loop: true,
          direction: "horizontal" /*横向滑动*/,
          pagination: ".swiper-pagination" /*分页器*/,
          autoplay: {
            delay: 1000, //1秒切换一次
          },
          navigation: {
            nextEl: ".index_cooperate_button-next",
            prevEl: ".index_cooperate_button-prev",
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1000: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1366: {
              slidesPerView: 5,
              spaceBetween: 40,
            },
            1500: {
              slidesPerView: 6,
              spaceBetween: 50,
            },
          },
        });
      });
      new Swiper(".index_cooperate_container", {
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: true,
        loop: true,
        navigation: {
          nextEl: ".index_cooperate_button-next",
          prevEl: ".index_cooperate_button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1000: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1366: {
            slidesPerView: 5,
            spaceBetween: 40,
          },
          1500: {
            slidesPerView: 6,
            spaceBetween: 50,
          },
        },
      });
    },
    //获取url参数
    getUrlKey(name, url) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            url
            // eslint-disable-next-line no-sparse-arrays
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    //密钥登录
    thirdPart(value) {
      var posturl = this.config.baseUrl.pro + "/login/apiTicketLogin";
      // var posturl = "http://47.94.240.133:9007/adminsch/login/apiTicketLogin";
      let postdata = {
        Secretkey: value,
      };
      //登录
      return axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域
          data: postdata,
        })
        .then((resp) => {
          console.log(resp);
          if (resp.data.result.code == 0) {
            var data = resp.data.result;
            console.log("新闻站登录：");
            console.log(resp);
            localStorage.setItem("userid", data.data.user.id);
            localStorage.setItem("authToken", data.token);
            localStorage.setItem("account", data.data.user.user_Name);
            localStorage.setItem("realname", data.data.user.real_Name);
            localStorage.setItem("systype", data.data.sysType);
            localStorage.setItem("sendurl", data.data.url);
            localStorage.setItem("UserRoleId", data.data.user.role_Id);
            localStorage.setItem("className", data.data.user.className);
            let typeCode = this.getUrlKey("code", window.location.href);
            localStorage.setItem("thirdPart", typeCode);
            this.sendsystem = false;
            this.getConfig(true);
          } else {
            // this.$Message.error("登录失败，用户名或密码错误");
            this.$Modal.error({
              title: "提示",
              content: "登录失败，密钥已失效，请重新进入！",
              onOk: () => {
                window.location.href = localStorage.getItem("loginservice");
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$Modal.error({
            title: "提示",
            content: "登录失败，请重新进入！",
            onOk: () => {
              window.location.href = localStorage.getItem("loginservice");
            },
          });
          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
  },
  mounted() {
    let Secretkey = this.getUrlKey("Secretkey", window.location.href);
    if (Secretkey != "" && Secretkey != null && Secretkey != undefined) {
      let loginservice = this.getUrlKey("loginservice", window.location.href);
      localStorage.setItem("loginservice", loginservice);
      this.thirdPart(Secretkey);
    } else {
      this.loginStatus();
    }
    if (!this._isMobile()) {
      this.pc = true;
    } else {
      this.pc = false;
    }
    this.getData();
    //this.init();
    this.schoolData();
    this.swLoad();
  },
  watch: {
    cases() {
      var wow = new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true,
      });
      wow.init();
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.box11 {
  width: 300px;
  height: 200px;
  border-radius: 5px;
  position: fixed;
  text-align: left;
  padding: 10px;
  color: #ffffff;
  top: 0;
  left: 0;
  z-index: 10000;
  cursor: pointer;
  .span {
    width: 100%;
    color: #fff;
    background: #237ae4;
    padding: 6px 10px;
    font-size: 13px;
    span {
      cursor: pointer;
    }
  }
  .box-div {
    cursor: pointer;
    // color:#000;
    width: 340px;
    height: 220px;
    // padding:20px;
    //text-align: center;
    // img{
    //   width:300px;
    //   height:300px;
    // }
  }
}

.warp {
  width: 130px * 4;
  height: 120px;
  margin: 0 auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    &.ul-item {
      display: flex;
      .li-item {
        width: 120px;
        height: 120px;
        margin-right: 10px;
        line-height: 120px;
        background-color: #999;
        color: #fff;
        text-align: center;
        font-size: 30px;
      }
    }
  }
}
.suspension {
  width: 100px;
  background-color: rgba(255, 255, 255, 100);
  box-shadow: 0 5px 20px #efefef;
  padding: 10px 6px 6px;
  position: fixed;
  border-radius: 6px 0 0 6px;
  right: 0px;
  bottom: 50px;
  z-index: 100000000000;
  font-size: 12px;
  color: #00aeec;
  div {
    line-height: 20px;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue